import React from 'react';
import { ButtonProps, Spinner, Button } from 'reactstrap';
import type { ButtonColor } from '~/lib/UiTypes';
import './BusyButton.scss';

// The explicit `color` narrows reactstrap's `color?: string` to the known
// contextual colours (ButtonColor & string = ButtonColor) so a typo is a compile
// error; it propagates to AsyncButton/ActionButton, which build on this type.
// Intersect with `ButtonProps` rather than `Omit`-ing `color` off it — ButtonProps'
// `[key: string]: any` index signature makes Omit collapse every other prop to `any`.
export type BusyButtonProps = {
    iconClass?: string;
    busy?: boolean;
    color?: ButtonColor;
} & ButtonProps;

export default class BusyButton extends React.Component<BusyButtonProps> {
    render() {
        const { iconClass, busy, className, children, disabled, ...buttonProps } = this.props;

        const icon = iconClass && <i className={`icon ${iconClass} ${!children ? 'icon-only' : ''}`} />;
        const spinner = (
            <span className="busyButtonSpinner">
                <Spinner size="sm" aria-hidden="true" />
            </span>
        );

        return (
            <Button
                disabled={busy || disabled}
                aria-busy={busy}
                className={`busyButton ${className ?? ''}`}
                {...buttonProps}
            >
                {busy ? spinner : icon}
                {children}
            </Button>
        );
    }
}
